import { ADSyncerSpecifics, ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';
export class RemoveADIntegratorValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;
  public canRunForMultipleItems = false;
  public canRunOnMultipleCompanies = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (!ProtectedEntitiesHelper.acceptsAdIntegration(record)) {
      return false;
    }

    return (record.specifics as ADSyncerSpecifics).isAdSyncer === true;
  }
}
